// import React, { useMemo, useState } from "react";
// import moment from "moment";
// import { useGetAllNoteQuery, useGetAllTradeQuery } from "../slices/zerodhaApiSlice";

// const WEEKDAYS = ["S", "M", "T", "W", "T", "F", "S"];

// const rupee = (n) =>
//   `${n < 0 ? "-" : ""}₹${new Intl.NumberFormat("en-IN").format(Math.abs(Math.round(n)))}`;

// // "+1100" / "-875" (no symbol, like the design)
// const signed = (n) => `${n > 0 ? "+" : ""}${Math.round(n)}`;

// /**
//  * Props
//  *  - journalData: daily journal rows (same as before)
//  *  - onOpenNote:  called with the day's journal/note (or an empty note) when a day is tapped
//  *  - title:       optional page title ("Calendar") shown above the card
//  */
// const TradeCalendar = ({ journalData = [], onOpenNote, title }) => {
//   const { data: allnotesResponse } = useGetAllNoteQuery();
//   const allNotes = allnotesResponse?.data || [];

//   const [currentDate, setCurrentDate] = useState(new Date());
//   const { data: tradeLogs } = useGetAllTradeQuery();

//   /* ================= TRADE LOG MAP (day -> pnl + trades) ================= */
//   const tradeLogMap = useMemo(() => {
//     const map = {};
//     tradeLogs?.trades?.forEach((trade) => {
//       const tradeDate = trade.closing_date || trade.opening_date;
//       if (!tradeDate) return;
//       const key = moment(tradeDate).format("YYYY-MM-DD");
//       if (!map[key]) map[key] = { pnl: 0, trades: [] };
//       map[key].pnl += Number(trade.profit || 0);
//       map[key].trades.push(trade);
//     });
//     return map;
//   }, [tradeLogs]);

//   /* ================= JOURNAL + NOTES MAP ================= */
//   const journalMap = useMemo(() => {
//     const map = {};
//     [...(journalData || []), ...(allNotes || [])].forEach((j) => {
//       const date = j.trade_date || j.date || j._id;
//       const key = moment(date).format("YYYY-MM-DD");
//       if (!map[key]) map[key] = [];
//       map[key].push(j);
//     });
//     return map;
//   }, [journalData, allNotes]);

//   const year = currentDate.getFullYear();
//   const month = currentDate.getMonth();
//   const firstDay = new Date(year, month, 1).getDay(); // 0 = Sunday
//   const daysInMonth = new Date(year, month + 1, 0).getDate();
//   const weekCount = Math.ceil((firstDay + daysInMonth) / 7);

//   const keyOf = (day) => moment(new Date(year, month, day)).format("YYYY-MM-DD");
//   const getTradeLogByDate = (day) => tradeLogMap[keyOf(day)];
//   const getJournalByDate = (day) => journalMap[keyOf(day)] || [];
//   const getNoteByDate = (day) =>
//     allNotes.find((n) => moment(n.trade_date).format("YYYY-MM-DD") === keyOf(day));

//   /* ================= MONTHLY + WEEKLY PNL (same source as the day cells) ================= */
//   const monthlyPnl = useMemo(() => {
//     let total = 0;
//     for (let d = 1; d <= daysInMonth; d += 1) {
//       total += tradeLogMap[moment(new Date(year, month, d)).format("YYYY-MM-DD")]?.pnl || 0;
//     }
//     return total;
//   }, [tradeLogMap, year, month, daysInMonth]);

//   const weeklyPnl = (week) => {
//     let total = 0;
//     for (let c = 0; c < 7; c += 1) {
//       const day = week * 7 + c - firstDay + 1;
//       if (day >= 1 && day <= daysInMonth) total += getTradeLogByDate(day)?.pnl || 0;
//     }
//     return total;
//   };

//   const openDay = (day) => {
//     const journal = getJournalByDate(day);
//     if (!onOpenNote) return;
//     onOpenNote(
//       journal.length > 0
//         ? journal[0]
//         : { trade_date: keyOf(day), title: "", content: "" }
//     );
//   };

//   return (
//     <div className="glass-scope">
//       {title && (
//         <div className="gd-head">
//           <h1>{title}</h1>
//         </div>
//       )}

//       <div className="glass-card cal">
//         {/* Month switcher */}
//         <div className="cal-nav">
//           <button type="button" aria-label="Previous month" onClick={() => setCurrentDate(new Date(year, month - 1, 1))}>‹</button>
//           <div className="cal-title">{moment(currentDate).format("MMMM YYYY")}</div>
//           <button type="button" aria-label="Next month" onClick={() => setCurrentDate(new Date(year, month + 1, 1))}>›</button>
//         </div>

//         <div className="cal-banner">Monthly P&amp;L {rupee(monthlyPnl)}</div>
//         <div className="cal-hint">Tap any day to add a note</div>

//         <div className="cal-grid">
//           <div className="cal-dow">
//             {WEEKDAYS.map((d, i) => <span key={`${d}-${i}`}>{d}</span>)}
//           </div>

//           {Array.from({ length: weekCount }, (_, week) => (
//             <div key={week}>
//               <div className="cal-week">
//                 {Array.from({ length: 7 }, (_, c) => {
//                   const day = week * 7 + c - firstDay + 1;
//                   if (day < 1 || day > daysInMonth) {
//                     return <div key={c} className="cal-day cal-day--blank" />;
//                   }

//                   const trade = getTradeLogByDate(day);
//                   const hasNote = Boolean(getNoteByDate(day));
//                   const state = !trade || trade.pnl === 0 ? "idle" : trade.pnl > 0 ? "win" : "loss";

//                   return (
//                     <button
//                       key={c}
//                       type="button"
//                       className={`cal-day cal-day--${state}`}
//                       onClick={() => openDay(day)}
//                       aria-label={`${moment(new Date(year, month, day)).format("D MMMM")}${trade ? `, net ${rupee(trade.pnl)}` : ""}`}
//                     >
//                       {hasNote && <span className="cal-day__dot" />}
//                       <span className="cal-day__num">{day}</span>
//                       {trade && trade.pnl !== 0 && <span className="cal-day__amt">{signed(trade.pnl)}</span>}
//                     </button>
//                   );
//                 })}
//               </div>
//               <div className="cal-weektotal">week {rupee(weeklyPnl(week))}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TradeCalendar;



import React, { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { useGetAllNoteQuery, useGetAllTradeQuery } from "../slices/zerodhaApiSlice";

const WEEKDAYS = ["S", "M", "T", "W", "T", "F", "S"];

const rupee = (n) =>
  `${n < 0 ? "-" : ""}₹${new Intl.NumberFormat("en-IN").format(Math.abs(Math.round(n)))}`;

// "+1100" / "-875" (no symbol, like the design)
const signed = (n) => `${n > 0 ? "+" : ""}${Math.round(n)}`;

/**
 * Props
 *  - journalData: daily journal rows (same as before)
 *  - onOpenNote:  called with the day's journal/note (or an empty note) when a day is tapped
 *  - title:       optional page title ("Calendar") shown above the card
 *  - onMonthChange: optional, called with the first day of the month being shown
 */
const TradeCalendar = ({ journalData = [], onOpenNote, title, onMonthChange }) => {
  const { data: allnotesResponse } = useGetAllNoteQuery();
  const allNotes = allnotesResponse?.data || [];

  const [currentDate, setCurrentDate] = useState(new Date());
  const { data: tradeLogs } = useGetAllTradeQuery();

  /* ================= TRADE LOG MAP (day -> pnl + trades) ================= */
  const tradeLogMap = useMemo(() => {
    const map = {};
    tradeLogs?.trades?.forEach((trade) => {
      const tradeDate = trade.closing_date || trade.opening_date;
      if (!tradeDate) return;
      const key = moment(tradeDate).format("YYYY-MM-DD");
      if (!map[key]) map[key] = { pnl: 0, trades: [] };
      map[key].pnl += Number(trade.profit || 0);
      map[key].trades.push(trade);
    });
    return map;
  }, [tradeLogs]);

  /* ================= JOURNAL + NOTES MAP ================= */
  const journalMap = useMemo(() => {
    const map = {};
    [...(journalData || []), ...(allNotes || [])].forEach((j) => {
      const date = j.trade_date || j.date || j._id;
      const key = moment(date).format("YYYY-MM-DD");
      if (!map[key]) map[key] = [];
      map[key].push(j);
    });
    return map;
  }, [journalData, allNotes]);

  const year = currentDate.getFullYear();
  const month = currentDate.getMonth();
  const firstDay = new Date(year, month, 1).getDay(); // 0 = Sunday
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const weekCount = Math.ceil((firstDay + daysInMonth) / 7);

  // tell the page which month is on screen (so it can load that month's journal)
  useEffect(() => {
    if (onMonthChange) onMonthChange(new Date(year, month, 1));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year, month]);

  const keyOf = (day) => moment(new Date(year, month, day)).format("YYYY-MM-DD");
  const getTradeLogByDate = (day) => tradeLogMap[keyOf(day)];
  const getJournalByDate = (day) => journalMap[keyOf(day)] || [];
  const getNoteByDate = (day) =>
    allNotes.find((n) => moment(n.trade_date).format("YYYY-MM-DD") === keyOf(day));

  /* ================= MONTHLY + WEEKLY PNL (same source as the day cells) ================= */
  const monthlyPnl = useMemo(() => {
    let total = 0;
    for (let d = 1; d <= daysInMonth; d += 1) {
      total += tradeLogMap[moment(new Date(year, month, d)).format("YYYY-MM-DD")]?.pnl || 0;
    }
    return total;
  }, [tradeLogMap, year, month, daysInMonth]);

  const weeklyPnl = (week) => {
    let total = 0;
    for (let c = 0; c < 7; c += 1) {
      const day = week * 7 + c - firstDay + 1;
      if (day >= 1 && day <= daysInMonth) total += getTradeLogByDate(day)?.pnl || 0;
    }
    return total;
  };

  const openDay = (day) => {
    const journal = getJournalByDate(day);
    if (!onOpenNote) return;
    onOpenNote(
      journal.length > 0
        ? journal[0]
        : { trade_date: keyOf(day), title: "", content: "" }
    );
  };

  return (
    <div className="glass-scope">
      {title && (
        <div className="gd-head">
          <h1>{title}</h1>
        </div>
      )}

      <div className="glass-card cal">
        {/* Month switcher */}
        <div className="cal-nav">
          <button type="button" aria-label="Previous month" onClick={() => setCurrentDate(new Date(year, month - 1, 1))}>‹</button>
          <div className="cal-title">{moment(currentDate).format("MMMM YYYY")}</div>
          <button type="button" aria-label="Next month" onClick={() => setCurrentDate(new Date(year, month + 1, 1))}>›</button>
        </div>

        <div className="cal-banner">Monthly P&amp;L {rupee(monthlyPnl)}</div>
        <div className="cal-hint">Tap any day to add a note</div>

        <div className="cal-grid">
          <div className="cal-dow">
            {WEEKDAYS.map((d, i) => <span key={`${d}-${i}`}>{d}</span>)}
          </div>

          {Array.from({ length: weekCount }, (_, week) => (
            <div key={week}>
              <div className="cal-week">
                {Array.from({ length: 7 }, (_, c) => {
                  const day = week * 7 + c - firstDay + 1;
                  if (day < 1 || day > daysInMonth) {
                    return <div key={c} className="cal-day cal-day--blank" />;
                  }

                  const trade = getTradeLogByDate(day);
                  const hasNote = Boolean(getNoteByDate(day));
                  const state = !trade || trade.pnl === 0 ? "idle" : trade.pnl > 0 ? "win" : "loss";

                  return (
                    <button
                      key={c}
                      type="button"
                      className={`cal-day cal-day--${state}`}
                      onClick={() => openDay(day)}
                      aria-label={`${moment(new Date(year, month, day)).format("D MMMM")}${trade ? `, net ${rupee(trade.pnl)}` : ""}`}
                    >
                      {hasNote && <span className="cal-day__dot" />}
                      <span className="cal-day__num">{day}</span>
                      {trade && trade.pnl !== 0 && <span className="cal-day__amt">{signed(trade.pnl)}</span>}
                    </button>
                  );
                })}
              </div>
              <div className="cal-weektotal">week {rupee(weeklyPnl(week))}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TradeCalendar;